import axios from 'axios';
import { message } from "ant-design-vue";
import router from "../router/index";
import {getToken,getAppKey,setHintStatus,getHintStatus,removeHintStatus} from "@/store/cache.js"
import vuex from "@/store/index.js"

const service = axios.create({

    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'country':'1',
        'App-Key':'1',
        'Cache-Control': 'no-cache' //重点清除接口的缓存
    },
    withCredentials: true
});


service.interceptors.request.use(
    config => {
        config.headers['token'] = getToken();
        config.headers['App-Key'] = getAppKey();
        return config;
    },
    error => {
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            let data = response.data;
            // 防止下载接口抛错
            if( data.toString() !== "[object Blob]" && data.code !== 0  ){
                if(data.code === 401  ){

                    let status = getHintStatus();
                    if( status == null ){
                        setHintStatus();
                        message.error(data.msg)
                        router.push("/login");
                    }else {
                        removeHintStatus();
                    }

                }else if(data.code === 200){
                    // errorHint(data.msg)
                }else {
                    message.error(data.msg)
                }

            }else{
                removeHintStatus();
            }

            return data;
        } else {
            message.error(response.statusText)
            Promise.reject();
        }
    },
    error => {
        console.log(error);

        switch (error.response.status) {
            case 401:
                router.push("/login");
                if (vuex.state.ismsgBox == 0) {
                    // 错误信息
                    message.error(error);
                    // 修改tokenStatus状态，防止多次点击
                    vuex.commit('changemsgBox', 1)
                }
                return Promise.reject();
            case 500:
                if (vuex.state.ismsgBox == 0) {
                    // 错误信息
                    message.error(error);
                    // 修改tokenStatus状态，防止多次点击
                    vuex.commit('changemsgBox', 1)
                }
                return Promise.reject();
        }

        message.error(error);
    }
);


function jsonData(data){
    return  JSON.stringify(data)
}
/**
 *
 * @param opt{url,data}
 * @returns {Promise<unknown>}
 */
service.axiosPost=(opt)=>{
    return new Promise((resolve, reject) => {
        service({
            url: opt.url,
            method: 'POST',
            data:   jsonData(opt.data),
        }).then((data)=>{
            resolve(data);
        }).catch((err)=>{
            reject(err);
        })
    })
}

/**
 *
 * @param opt{url,data}
 * @returns {Promise<unknown>}
 */
service.axiosPut=(opt)=>{
    return new Promise((resolve, reject) => {
        service({
            url: opt.url,
            method: 'PUT',
            data:   jsonData(opt.data),
        }).then((data)=>{

            resolve(data);

        }).catch((err)=>{
            reject(err);
        })
    })

}

/**
 *
 * @param opt {url,params}
 * @returns {Promise<unknown>}
 */
service.axiosGet=( opt)=>{
    return new Promise((resolve, reject) => {
        service({
            url: opt.url,
            method: 'GET',
            params : opt.params,
        }).then((data)=>{
            resolve(data);
        }).catch((err)=>{
            reject(err);
        })
    })

}



service.axiosDelete=( opt)=>{
    return new Promise((resolve, reject) => {

        service({
            url: opt.url,
            method: 'DELETE',
            params : opt.params,
        }).then((data)=>{
            resolve(data);
        }).catch((err)=>{
            reject(err);
        })
    })

}



service.axiosDownload=(opt)=>{
    return new Promise((resolve, reject) => {
        service({
            url: opt.url,
            method: 'GET',
            responseType: 'blob',
        }).then((data)=>{
            resolve(data);
        }).catch((err)=>{
            reject(err);
        })
    })

}
/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
service.adornUrl = (actionName) => {
    // 非生产环境 && 开启代理, 接口前缀统一使用[/api/]前缀做代理拦截!
    return  actionName
}

service.axiosUpload=(opt)=>{
    return new Promise((resolve, reject) => {
        service({
            url: opt.url,
            method: 'POST',
            data: opt.data,
            headers: {'Content-Type': 'multipart/form-data'},
        }).then((data)=>{
            if(data.code === 200){
                resolve(data);
            }else {
                reject(data);
            }
        }).catch((err)=>{
            reject(err);
        })
    })

}

service.axiosImgUrl=(objectName)=>{
    if(!objectName)return
    return process.env.VUE_APP_BASE_API + '/file/download/' + objectName + '?country=1&token=' + getToken()
}

service.axiosImgSmallUrl=(objectName)=>{
    if(!objectName)return
    return process.env.VUE_APP_BASE_API + '/file/download/' + objectName + '/small?country=1&token=' + getToken()
}

export default service;
